<script setup lang="ts">
import { PhBookOpenText, PhCloudCheck, PhPath } from '@phosphor-icons/vue'

const values = [
  {
    icon: PhBookOpenText,
    title: '章节同步',
    text: '按照学段、年级、科目与教材版本组织实验内容。',
  },
  {
    icon: PhPath,
    title: '完整学习路径',
    text: '从实验介绍、动手操作到完成记录，过程清晰连贯。',
  },
  {
    icon: PhCloudCheck,
    title: '多端同步',
    text: '同一账号跨设备使用，选择与学习记录持续同步。',
  },
]
</script>

<template>
  <section class="trust-section">
    <div class="container trust-inner">
      <div class="section-heading">
        <h2>围绕<span>真正的理解</span><br />来设计</h2>
      </div>
      <div class="trust-list">
        <article v-for="value in values" :key="value.title">
          <component :is="value.icon" :size="30" weight="duotone" />
          <div>
            <h3>{{ value.title }}</h3>
            <p>{{ value.text }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>
